
const addDays = (date: Date, days: number) => {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
};

const addMonths = (date: Date, months: number) => {
  const result = new Date(date);
  result.setMonth(result.getMonth() + months);
  return result;
};

const addMinutes = (time: number, minutes: number) => {
  const dat = time + (60000 * minutes);
  return dat;
};

const getWeekStart: () => "en" | "se"  = () => {
    const loc = Intl.DateTimeFormat().resolvedOptions().locale; // e.g. "en-SE", "fr-CA"

    let region: string | undefined;
    const m = loc.match(/-([A-Za-z]{2})\b/);
    region = m?.[1].toUpperCase();                     // → "SE"

    return region === "US" || region === "CA" ? "en" : "se";
}

const numberOfNights = (from:number, to:number) => {
  const fromDate = new Date(from);
  const toDate = new Date(to);

  fromDate.setHours(12);
  fromDate.setMinutes(0);
  fromDate.setSeconds(0);
  fromDate.setMilliseconds(0);

  toDate.setHours(15);
  toDate.setMinutes(0);
  toDate.setSeconds(0);
  toDate.setMilliseconds(0);

  return Math.floor((toDate.getTime() - fromDate.getTime()) / (24*60*60*1000));
};

const formatDate = (daty: Date) => {
  const date = new Date(daty);
  const year = date.getFullYear();
  let day = '' + date.getDate();
  let month = '' + (date.getMonth() + 1);

  if (month.length < 2) { month = '0' + month; }
  if (day.length < 2) { day = '0' + day; }

  return [year, month, day].join('-');
};

const isSameDay = (dateA: Date, dateB: Date) => {
  if (dateA.getFullYear() === dateB.getFullYear()
    && dateA.getMonth() === dateB.getMonth()
    && dateA.getDate() === dateB.getDate()) {
    return true;
  }
  return false;
};

const getWeekNum = (dateToCheck:Date) => {
  const date:Date = new Date(dateToCheck);
  date.setHours(0, 0, 0, 0);
  // Thursday in current week decides the year.
  date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
  // January 4 is always in week 1.
  const week1 = new Date(date.getFullYear(), 0, 4);
  // Adjust to Thursday in week 1 and count number of weeks from date to week1.
  return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000
                        - 3 + (week1.getDay() + 6) % 7) / 7);
};

const toIsoDateTime = (dateTime:Date) => {
  return toIsoDate(dateTime)+"T"+toIsoTime(dateTime);
};

const toIsoDate = (date:Date) => {
  return date.getFullYear()+"-"+(""+(date.getMonth()+1)).padStart(2, '0')+"-"+(""+date.getDate()).padStart(2, '0');
};

const toIsoTime = (time:Date) => {
  const hours = time.getHours();
  const minutes = time.getMinutes();
  return (""+hours).padStart(2, '0') + ":" + (""+minutes).padStart(2, '0');
};

export { addDays, addMinutes, addMonths, formatDate, getWeekNum, isSameDay, toIsoDate, toIsoDateTime, toIsoTime, numberOfNights, getWeekStart};



// WEBPACK FOOTER //
// ./src/helpers/DateHelper.tsx